<div>
    <h2 mat-dialog-title fxLayoutAlign="space-between">
        {{parentType}} Mailing Addresses
        <button *ngIf="!viewOnly" mat-fab color="primary" class="addButton" (click)="addClicked()" matTooltip="Add Mailing Address" tabindex="-1">
            <mat-icon>add</mat-icon>
        </button>
    </h2>

    <mat-dialog-content [formGroup]="dialogForm" fxLayout="column" fxLayoutAlign="space-between stretch">
        <mailing-address-list [mailingAddresses]="mailingAddresses" [usages]="usages" [viewOnly]="viewOnly">
        </mailing-address-list>
    </mat-dialog-content>

    <mat-dialog-actions fxLayoutAlign="end end">
        <button mat-button mat-dialog-close telemetry="Submission-MailingAddressCancel" (click)="cancelClicked()">
            Cancel
        </button>
        <button *ngIf="!viewOnly" mat-button [disabled]="invalid" (click)="doneClicked()" telemetry="Submission-MailingAddressDone">
            Done
        </button>
    </mat-dialog-actions>
</div>